<template>
  <div>
    <el-col :span="24">
      <div class="titleTop">
        <h5 style="margin: 0;">
          Function display
        </h5>
      </div>
    </el-col>
    <el-col :span="24" id="carousel">
      <el-carousel class="bor" :height="carouselHeight" :autoplay="false">
        <el-carousel-item v-for="item in homePictureList" :key="item.id">
          <a
            v-if="item.imgUrl !== ''"
            href="javascript:void(0);"
            @click="openLink(item.url)"
            style="display: flex;justify-content: center;align-items: center;"
          >
            <img
              style="max-width: 100%;max-height:100%"
              :src="pathConfig.indexImgPath + item.imgUrl"
              alt=""
            />
          </a>
        </el-carousel-item>
      </el-carousel>
    </el-col>
  </div>
</template>
<script>
import { pathConfig } from '../assets/util/baseConfig'

export default {
  props: {
    homePictureList: {
      type: Array,
      default: function() {
        return [
          {
            id: 0,
            url: '',
            imgUrl: ''
          }
        ]
      }
    },
    carouselHeight: {
      type: String
    }
  },
  data() {
    return {
      pathConfig: pathConfig
    }
  },
  methods: {
    openLink(link) {
      window.open(link, '_blank')
    }
  }
}
</script>

<style scoped>
.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.bor {
  border: 1px solid #e0dddd;
}
</style>



// WEBPACK FOOTER //
// src/components/bottomPic.vue